( function () {
    'use strict';

    window.addEventListener( 'load', function () {

        let activeModal   = null;
        let activeOverlay = null;
        let sourceWrapper = null;
        let escListener   = null;
        let isAnimating   = false;

        /* ── Scroll lock ──────────────────────────────────────── */

        function lockScroll() {
            var w = window.innerWidth - document.documentElement.clientWidth;
            document.body.style.overflow     = 'hidden';
            document.body.style.paddingRight = w + 'px';
        }

        function unlockScroll() {
            document.body.style.overflow     = '';
            document.body.style.paddingRight = '';
        }

        /* ── Apply inline styles (no CSS-file dependency) ─────── */

        function styleSubElements( modal ) {
            var header = modal.querySelector( '.modal-header' );
            if ( header ) {
                Object.assign( header.style, {
                    backgroundColor : '#e5f5fb',
                    borderBottom    : '2px solid #009dd9',
                    padding         : '16px 24px',
                    display         : 'flex',
                    alignItems      : 'center',
                    position        : 'relative',
                    boxSizing       : 'border-box',
                    flexShrink      : '0',
                    width           : '100%',
                } );
            }

            var title = modal.querySelector( '.modal-title' );
            if ( title ) {
                Object.assign( title.style, {
                    fontSize   : '18px',
                    fontWeight : '700',
                    margin     : '0',
                } );
            }

            var desc = modal.querySelector( '.modal-header .card-description' );
            if ( desc ) {
                Object.assign( desc.style, {
                    margin     : '0 0 0 12px',
                    fontSize   : '14px',
                    fontWeight : '400',
                    color      : '#4a4a4a',
                } );
            }

            var closeBtn = modal.querySelector( '.br-modal-close' );
            if ( closeBtn ) {
                Object.assign( closeBtn.style, {
                    position   : 'absolute',
                    right      : '18px',
                    top        : '50%',
                    transform  : 'translateY(-50%)',
                    fontSize   : '24px',
                    fontWeight : 'bold',
                    lineHeight : '1',
                    cursor     : 'pointer',
                    opacity    : '0.7',
                    background : 'none',
                    border     : 'none',
                    padding    : '0',
                    color      : 'inherit',
                } );
            }

            var scrollable = modal.querySelector( '.scrollable-content' );
            if ( scrollable ) {
                Object.assign( scrollable.style, {
                    padding   : '20px',
                    overflowY : 'auto',
                    maxHeight : 'calc(90vh - 80px)',
                    flex      : '1 1 auto',
                    boxSizing : 'border-box',
                } );
            }
        }

        function styleOverlay( el ) {
            var s = el.style;
            s.position   = 'fixed';
            s.inset      = '0';
            s.background = 'rgba(0,0,0,.45)';
            s.zIndex     = '2147483646';
            s.opacity    = '0';
            s.transition = 'opacity .35s ease';
        }

        function styleModalClosed( el ) {
            el.classList.remove( 'is-visible' );
            var s = el.style;
            s.position      = 'fixed';
            s.top           = '50%';
            s.left          = '50%';
            s.width         = '90%';
            s.maxWidth      = '800px';
            s.maxHeight     = '90vh';
            s.background    = '#fff';
            s.borderRadius  = '10px';
            s.boxShadow     = '0 30px 80px rgba(0,0,0,.35)';
            s.display       = 'flex';
            s.flexDirection = 'column';
            s.alignItems    = 'stretch';
            s.overflow      = 'hidden';
            s.zIndex        = '2147483647';
            s.transform     = 'translate(-50%,-50%) scale(0.2)';
            s.opacity       = '0';
            s.visibility    = 'hidden';
            s.pointerEvents = 'none';
            s.transition    = 'transform .42s cubic-bezier(.22,1,.36,1), opacity .28s ease, visibility 0s linear .42s';
        }

        function styleModalOpen( el ) {
            // La classe is-visible est nécessaire si le CSS de cards-modal est chargé
            // (il utilise body > .modal-content.is-visible { opacity:1 !important })
            el.classList.add( 'is-visible' );
            var s = el.style;
            s.transform     = 'translate(-50%,-50%) scale(1)';
            s.opacity       = '1';
            s.visibility    = 'visible';
            s.pointerEvents = 'auto';
            s.transition    = 'transform .42s cubic-bezier(.22,1,.36,1), opacity .28s ease, visibility 0s linear 0s';
        }

        function styleModalClosing( el ) {
            el.classList.remove( 'is-visible' );
            var s = el.style;
            s.transform     = 'translate(-50%,-50%) scale(0.15)';
            s.opacity       = '0';
            s.visibility    = 'visible';
            s.pointerEvents = 'none';
            s.transition    = 'transform .28s cubic-bezier(.55,0,1,.45), opacity .22s ease';
        }

        /* ── Close ────────────────────────────────────────────── */

        function closeModal() {
            if ( ! activeModal || isAnimating ) return;
            isAnimating = true;

            if ( escListener ) {
                document.removeEventListener( 'keydown', escListener );
                escListener = null;
            }

            styleModalClosing( activeModal );
            if ( activeOverlay ) activeOverlay.style.opacity = '0';

            setTimeout( function () {
                if ( activeModal && sourceWrapper ) {
                    activeModal.style.cssText = '';
                    sourceWrapper.appendChild( activeModal );
                }
                if ( activeOverlay ) activeOverlay.remove();

                document.body.classList.remove( 'modal-open' );
                unlockScroll();

                activeModal   = null;
                activeOverlay = null;
                sourceWrapper = null;
                isAnimating   = false;

                if ( history.pushState ) {
                    history.pushState( '', document.title, window.location.pathname + window.location.search );
                }
            }, 300 );
        }

        /* ── Open ─────────────────────────────────────────────── */

        function openModalById( id ) {
            if ( isAnimating ) return;

            if ( activeModal ) {
                closeModal();
                setTimeout( function () { openModalById( id ); }, 320 );
                return;
            }

            var wrapper = document.querySelector( '.br-modal-block[data-modal-id="' + id + '"]' );
            if ( ! wrapper ) return;

            var modalContent = wrapper.querySelector( '.modal-content' );
            if ( ! modalContent ) return;

            isAnimating   = true;
            sourceWrapper = wrapper;
            activeModal   = modalContent;

            // Overlay
            activeOverlay           = document.createElement( 'div' );
            activeOverlay.className = 'br-modal-overlay';
            styleOverlay( activeOverlay );

            // Style sub-elements (header, close btn, scrollable) — no CSS-file dependency
            styleSubElements( activeModal );

            // Modal — initial (closed) state
            styleModalClosed( activeModal );

            document.body.appendChild( activeOverlay );
            document.body.appendChild( activeModal );
            document.body.classList.add( 'modal-open' );
            lockScroll();

            activeOverlay.addEventListener( 'click', closeModal );
            activeOverlay.addEventListener( 'touchmove', function ( e ) {
                e.preventDefault();
            }, { passive: false } );

            var closeBtn = activeModal.querySelector( '.br-modal-close' );
            if ( closeBtn ) closeBtn.addEventListener( 'click', closeModal );

            escListener = function ( e ) {
                if ( e.key === 'Escape' ) closeModal();
            };
            document.addEventListener( 'keydown', escListener );

            requestAnimationFrame( function () {
                activeOverlay.style.opacity = '1';
                styleModalOpen( activeModal );

                if ( typeof window.brBlocksRefreshTabs === 'function' ) {
                    window.brBlocksRefreshTabs( activeModal );
                }
                if ( typeof window.brBlocksRefreshFloorplan === 'function' ) {
                    window.brBlocksRefreshFloorplan( activeModal );
                }

                setTimeout( function () { isAnimating = false; }, 420 );
            } );
        }

        /* ── Click delegation ─────────────────────────────────── */

        document.addEventListener( 'click', function ( e ) {
            var trigger = e.target.closest( 'a[href^="#"], [data-br-modal]' );
            if ( ! trigger ) return;

            var id = trigger.dataset.brModal ||
                     ( trigger.getAttribute( 'href' ) || '' ).slice( 1 );
            if ( ! id ) return;

            var wrapper = document.querySelector( '.br-modal-block[data-modal-id="' + id + '"]' );
            if ( ! wrapper ) return;

            e.preventDefault();
            openModalById( id );
        } );

        /* ── Open from URL hash on page load ──────────────────── */

        function openFromHash() {
            var hash = ( window.location.hash || '' ).slice( 1 );
            if ( hash ) openModalById( hash );
        }

        openFromHash();
        window.addEventListener( 'hashchange', openFromHash );
    } );
} )();
